import { istockphotoImg } from '../assets/images';

function Poulet() {
  return (
    <div>
      <div
        className="hero h-[18rem] bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${istockphotoImg})`,
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay bg-opacity-60"></div>
        <div className="hero-content text-neutral-content text-center">
          <h1 className="mb-5 text-5xl text-white font-bold">
            Tout savoir sur les poules pondeuses
          </h1>
        </div>
      </div>

      <div className="px-6 lg:px-32">
        <h1 className="text-4xl bg-black text-white p-4 text-center font-bold my-10">
          Tout savoir sur les poules pondeuses
        </h1>

        <div className="text-gray-700 text-xl gap-8 leading-10 my-20">
          <p>
            Il existe de plusieurs races de poules : poule pondeuse, poule
            couveuse, poule naine, poule d’ornement… Chaque race a ses
            qualités propres.
          </p>
          <p>
            Comme leurs noms l’indiquent, les poules pondeuses sont
            particulièrement douées pour pondre de façon régulière. Elles ont
            donc un meilleur rendement de ponte que d’autres races. Les poules
            pondeuses sont utilisées principalement pour le commerce d’oeufs de
            consommation.
          </p>
          <p>
            Les poules pondeuses n’ont pas besoin d’être cochées par un coq dans
            le poulailler pour pondre des oeufs. Le coq est nécessaire uniquement
            si vous souhaitez avoir des œufs fécondés et donc des poussins. Les
            poules couveuses sont dans ce cas très pratiques car elles vont
            couver naturellement les œufs pondus et élever les futurs poussins.
            Omnivores, les poules doivent avoir une alimentation équilibrée et
            variée. Ce qu’elles picorent a une incidence directe sur leur
            bien-être et leur santé.
          </p>
          <p>
            Elles picorent en petite quantité 100 à 150 g / jour selon la race
            à une heure fixe. Idéalement, leur alimentation doit être composée
            de céréales et de protéines. Côté céréales, privilégiez le maïs.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Poulet;
